import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from "classnames";
import { formatNumber } from "../../../lib/number";
import Metric from "../../Metric";
import Tooltip from "..";
import { appendTimezone, timestampToDateString } from "../../../lib/date";
import { getThresholdsColorForValue } from "../../../lib/thresholds";
import style from "./style.module.scss";
export default function ColumnDistributionTooltip(props) {
    const point = props.point;
    const series = point.series.userOptions;
    const distributionInfoJSX = [];
    const metricInfoJSX = [];
    let wideClass = "";
    //Loop through and get all the extra info if it's a stackedDistribution that the tool tip represents.
    point.series.chart.series.forEach((series) => {
        const scSeries = series.userOptions;
        const matchingPoint = scSeries.data.find((seriesPoint) => {
            return seriesPoint.x === point.x;
        });
        if (matchingPoint) {
            const color = String(series.color) || String(matchingPoint.color);
            if (matchingPoint.num) {
                wideClass = style["distribution-column-tooltip--wide"];
                const numPageViews = matchingPoint.num;
                distributionInfoJSX.push(_jsxs("div", { className: style["distribution-row"], style: { color }, children: [_jsx("div", { children: series.name }), _jsxs("div", { children: [numPageViews, "\u00A0page\u00A0views\u00A0(", Math.round(Number(matchingPoint.y)), "%)"] })] }));
            }
            else {
                distributionInfoJSX.push(_jsxs("div", { className: style["distribution-row"], style: { color }, children: [_jsx("div", { children: series.name }), _jsxs("div", { children: [Math.round(Number(matchingPoint.y)), "%"] })] }));
            }
        }
    });
    if (series.data[point.index].stat === 0 || series.data[point.index].stat) {
        let color = "#FFFFFF";
        if (series.thresholds) {
            color = getThresholdsColorForValue(series.thresholds, Number(series.data[point.index].stat));
        }
        metricInfoJSX.push(_jsx(Metric, { color: color, title: series.metricName, value: `${formatNumber(Number(series.data[point.index].stat))}${series.numLabel}` }));
    }
    return (_jsx(Tooltip, { className: classNames(style["distribution-column-tooltip"], wideClass), children: _jsxs("div", { children: [appendTimezone(timestampToDateString(point.x / 1000)), metricInfoJSX, _jsx("div", { className: style["distribution-column-tooltip__seperator"] }), distributionInfoJSX] }) }));
}
